// Consent for the optional tools on the site: Hotjar session recordings and,
// once the build has a measurement ID, Google Analytics 4.
// Plain browser code, no dependency. Nothing optional loads before "Accept".
const KEY = 'cloudpouch.consent';
// The measurement ID (G-...) is public. The build reads it from GATSBY_GA4_ID
// (gatsby-node.js); without it GA4 is off and nothing else changes.
const GA4_ID = process.env.GA4_MEASUREMENT_ID || '';
export const GA4_ENABLED = !!GA4_ID;
// A choice made for Hotjar alone does not cover Google Analytics: the build
// that turns GA4 on asks again; a build without GA4 keeps earlier choices.
const VERSION = GA4_ENABLED ? 2 : 1;
const MAX_AGE_MS = 182 * 24 * 3600 * 1000; // about 6 months, then we ask again
const HOTJAR_ID = 2721126;
const HOTJAR_SV = 6;

export const read = () => {
  try {
    const c = JSON.parse(window.localStorage.getItem(KEY));
    if (c && c.v === VERSION && Date.now() - c.at < MAX_AGE_MS) return c;
  } catch (e) {
    // blocked storage: treated as "no decision", the tools stay off
  }
  return null;
};

export const loadHotjar = () => {
  if (typeof window === 'undefined' || window.__cpHj) return;
  window.__cpHj = true;
  /* eslint-disable */
  (function (h, o, t, j, a, r) {
    h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
    h._hjSettings = { hjid: HOTJAR_ID, hjsv: HOTJAR_SV };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script'); r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  /* eslint-enable */
};

// Google Analytics 4, loaded only after "Accept". The tag reads the address of
// the page, so utm_* in it reach Analytics as the campaign of the visit.
// Consent defaults: no advertising storage; analytics storage is granted
// because this runs only after the visitor accepted.
export const loadGa4 = () => {
  if (!GA4_ENABLED || typeof window === 'undefined' || window.__cpGa4) return;
  window.__cpGa4 = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
  };
  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'granted',
  });
  window.gtag('js', new Date());
  window.gtag('config', GA4_ID);
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);
};

// A loaded script cannot be unloaded: remove what the tools stored, then reload.
const clearTools = () => {
  const host = window.location.hostname;
  const domains = [undefined, host, `.${host}`];
  document.cookie.split(';').forEach((raw) => {
    const name = raw.split('=')[0].trim();
    if (!name.startsWith('_hj') && !name.startsWith('_ga')) return;
    domains.forEach((d) => {
      document.cookie = `${name}=; Max-Age=0; path=/${d ? `; domain=${d}` : ''}`;
    });
  });
  [window.localStorage, window.sessionStorage].forEach((store) => {
    try {
      Object.keys(store)
        .filter((k) => k.startsWith('_hj'))
        .forEach((k) => store.removeItem(k));
    } catch (e) {
      // ignore
    }
  });
};

export const save = (analytics) => {
  const hadTools = !!window.__cpHj || !!window.__cpGa4;
  try {
    window.localStorage.setItem(
      KEY,
      JSON.stringify({ v: VERSION, analytics: !!analytics, at: Date.now() })
    );
  } catch (e) {
    // blocked storage: the choice only lasts for this page view
  }
  if (analytics) {
    loadHotjar();
    loadGa4();
  } else if (hadTools) {
    clearTools();
    window.location.reload();
    return;
  } else {
    clearTools();
  }
  window.dispatchEvent(new Event('cp-consent'));
};

export const openSettings = () => {
  window.dispatchEvent(new Event('cp-open-consent'));
};
